export enum WireType {
    ATM_CASH = "A",
    PAPER_CHECK = "C",
    INTERACTIVE_CHECK = "I",
    CONTRACT_TRANSFER = "T",
}

export default WireType;
